var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "content-padding" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-6 offset-3" },
        [
          _c("div", [_vm._v("Test Omise Add Card")]),
          _vm._v(" "),
          _c("div", { staticClass: "mt-4" }, [
            _vm._v("Omise Token: " + _vm._s(_vm.omiseToken))
          ]),
          _vm._v(" "),
          _c("payment-form", {
            ref: "paymentForm",
            attrs: { paymentData: _vm.paymentData }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "mt-4" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                on: {
                  click: function($event) {
                    return _vm.testOmise()
                  }
                }
              },
              [_vm._v("\n          Create Omise Token\n        ")]
            )
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f4422a2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f4422a2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment/TestOmise.vue
// module id = 2277
// module chunks = 0